import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

/**
 * Simplified Apollo Client for Coupling WNC website.
 * No tenant headers, no auth token — public mutations only (sales leads).
 * Uses VITE_GRAPHQL_URL env var directly.
 */
function createApolloClient() {
  const graphqlUrl = import.meta.env.VITE_GRAPHQL_URL || 'https://api.cplng.org/graphql';

  const httpLink = new HttpLink({
    uri: graphqlUrl,
  });

  return new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
      },
      query: {
        fetchPolicy: 'network-only',
      },
    },
  });
}

export const apolloClient = createApolloClient();
